import { createContext, useContext, useEffect, useState } from "react";
import apiService from "../services/api";

const SiteSettingsContext = createContext();

export const useSiteSettings = () => {
    const context = useContext(SiteSettingsContext);
    if (!context) {
        throw new Error("useSiteSettings must be used within SiteSettingsProvider");
    }
    return context;
};

export const SiteSettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState({
        notAcceptingOrders: false,
        websiteUnderMaintenance: false,
        comingSoon: false,
        customMarqueeMessage: ""
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSettings();
        const interval = setInterval(fetchSettings, 60000);
        return () => clearInterval(interval);
    }, []);

    const fetchSettings = async () => {
        try {
            const response = await apiService.getPublicSettings();
            if (response && response.status === "success" && response.data && response.data.settings) {
                setSettings(response.data.settings);
            }
        } catch (error) {
            console.error("Failed to fetch site settings:", error);
            setSettings({
                notAcceptingOrders: false,
                websiteUnderMaintenance: false,
                comingSoon: false,
                customMarqueeMessage: ""
            });
        } finally {
            setLoading(false);
        }
    };

    const value = {
        settings,
        loading,
        refreshSettings: fetchSettings,
        isNotAcceptingOrders: settings.notAcceptingOrders,
        isUnderMaintenance: settings.websiteUnderMaintenance,
        isComingSoon: settings.comingSoon
    };

    return (
        <SiteSettingsContext.Provider value={value}>
            {children}
        </SiteSettingsContext.Provider>
    );
};

